import { deepGet } from "../../../utils/utility";
import { SetModalType } from "./utils.type";
import { History, LocationState } from 'history';

const policyData = () => {
  const policyDataOBJ = localStorage.getItem("policyData") || "{}";
  return JSON.parse(policyDataOBJ);
};

export const getNifTomador = () => {
  return deepGet(policyData(), "nifTomador", "") || "";
};

export const getPolicyNumber = () => {
  return deepGet(policyData(), "numeroPoliza", "") || "";
};

export const getProductName = () => {
  return deepGet(policyData(), "producto", "") || "";
};

export const getSubramo = () => {
  return deepGet(policyData(), "subramo", "") || "";
};

export const getCollective = () => {
  return deepGet(policyData(), "numeroColectivo", "") || "";
};

export const getBusinessGroup= () => {
  return deepGet(policyData(), "grupo_negocio", "") || "";
};

export const getPolicyEndDate = () => {
  return deepGet(policyData(), "fechaVencimiento", "") || "";
};

export const getPolicySupplementDay = () => {
  return deepGet(policyData(), "fechaEfectoSuplemento", "") || "";
};

export const getPolicyData = () => {
  return policyData();
};

export const setPolicyData = (input: string, value: string) => {
  localStorage.setItem("policyData", JSON.stringify({...getPolicyData(), [input]: value }));
};

export const redirect = (setModal: SetModalType, history: History<LocationState>) => {
  setModal({ msg: "", status: false, type: "" });
  history.push(`/suplementos/${getPolicyNumber()}`);
};
